import { render, staticRenderFns } from "./SingleIpad.vue?vue&type=template&id=24580d72&"
import script from "./SingleIpad.vue?vue&type=script&lang=js&"
export * from "./SingleIpad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports